import { call, put } from 'redux-saga/effects';

import * as types from './agenda-item.types';
import * as actions from './agenda-item.actions';
import * as api from '../../api/request-config/agenda-item.api';

import { apiRequest } from '../../api/api.saga-services';
import { agendaItemSelectors } from './agenda-item.selectors';
import { select } from '../../../utils/selector.utils';
import { ICurrentAgendaIndex } from '../../page/page-storage/agenda-items/agenda-items.types';
import { IMeetingSimple } from '../meeting-simple/meeting-simple.types';
import { updateMeetingDurationFromAgenda } from '../meeting-simple/meeting-simple.saga-service';

export function* storeAgendaItem(agendaItem: types.IAgenda | types.IAgenda[]) {
  yield put(actions.storeAgendaItem(agendaItem));
}

export function* clearAgendaItem(agendaItemId: types.IAgendaItem['id']) {
  yield put(actions.clearAgendaItem(agendaItemId));
}

export function* getAgendaItems(meetingId?: IMeetingSimple['id']) {
  const agendaItems = (yield call(apiRequest, api.getAgendaItemsApi(meetingId))) as types.IAgendaItem[];

  yield call(storeAgendaItem, agendaItems);
  return agendaItems;
}

export function* clearAllAgendaItems() {
  const agendaIds: types.IAgendaItem['id'][] = yield select(agendaItemSelectors.selectResourceIds);
  yield put(actions.clearAgendaItem(agendaIds));
}

export function* saveAgendaItems(meetingId: IMeetingSimple['id'], agendaItems: types.IAgendaItem[]) {
  const agendaItemsResponse = (yield call(apiRequest, api.saveAgendaItemsApi(meetingId, agendaItems))) as any[];

  yield call(storeAgendaItem, agendaItemsResponse);

  // now update the duration of the meeting in the store
  yield call(updateMeetingDurationFromAgenda, meetingId, agendaItems);

  return agendaItemsResponse;
}

export function* moveStepAgenda(currentAgendaIndex: ICurrentAgendaIndex) {
  yield call(apiRequest, api.moveStepAgenda(currentAgendaIndex));
}
